export default "__VITE_ASSET__pR33Xlnw__"